'use client'

import { Image, PromoBanner } from '@vinted/web-ui'
import classNames from 'classnames'
import { useState } from 'react'

import { useBreakpoint } from '@marketplace-web/breakpoints/breakpoints-feature'
import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { useAsset } from '@marketplace-web/shared/assets'
import {
  FirstTimeListerGuidelineModel,
  itemUploadClickEvent,
} from '@marketplace-web/banners/banners-data'

import HowToSell from './HowToSell'

type Props = {
  banner: FirstTimeListerGuidelineModel
  uploadSessionId: string | null
}

const FirstTimeListing = ({ banner, uploadSessionId }: Props) => {
  const { track } = useTracking()
  const [isOpen, setIsOpen] = useState(false)
  const asset = useAsset('/assets/items/upload/first-time-listing')
  const breakpoints = useBreakpoint()
  const classes = classNames({
    'u-ui-margin-top-large u-ui-margin-horizontal-large': breakpoints.phones,
    'u-ui-margin-top-x-large u-ui-margin-horizontal-x-large': !breakpoints.phones,
  })

  const handleOpenClick = () => {
    track(itemUploadClickEvent({ target: 'learn_how_modal', uploadSessionId }))

    setIsOpen(true)
  }

  const handleCloseClick = () => {
    setIsOpen(false)
  }

  return (
    <div className={classes}>
      <PromoBanner
        icon={<Image src={asset('heart-loop.svg')} />}
        title={banner.title}
        body=""
        clickable
        onClick={handleOpenClick}
        actionText={banner.actionText}
        styling={PromoBanner.Styling.Tight}
        testId="first-time-listing-banner"
      />
      <HowToSell
        isOpen={isOpen}
        onClose={handleCloseClick}
        info={banner.additionalInformation}
        uploadSessionId={uploadSessionId}
      />
    </div>
  )
}

export default FirstTimeListing
